"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DummyWallet = void 0;
class DummyWallet {
    constructor() { }
    async signTransaction(_tx) {
        throw Error("Not supported by dummy wallet!");
    }
    async signAllTransactions(_txs) {
        throw Error("Not supported by dummy wallet!");
    }
    get publicKey() {
        throw Error("Not supported by dummy wallet!");
    }
}
exports.DummyWallet = DummyWallet;
